export default __webpack_public_path__ + "static/media/new-icon-dashboard-fill.86a0e973.svg";